import { ANALYTIC_PARAMS_ARRAY } from "../constants";
import type { AnalyticParamsType } from "../types";
import { getAnalyticsParam } from "./get-one";

export const getAll = () => {
  const result = ANALYTIC_PARAMS_ARRAY.reduce(
    (acc, param) => {
      const value = getAnalyticsParam(param);

      // Mutating object due to performance: https://biomejs.dev/linter/rules/no-accumulating-spread/
      if (value) acc[param] = value;

      return acc;
    },
    {} as Record<AnalyticParamsType, string>,
  );

  return result;
};
